import moment from 'moment';
import { WhatsappTemplateButtonTypeEnum } from 'src/app/parameters/message-templates/whatsapp-templates/shared/models/whatsapp-template-button-type.enum';

editWhatsappTemplateBoxController.$inject = ['$scope',
  '$mdDialog',
  'AngularWhatsappTemplatesService',
  'AlertingFactory',
  'elementView',
  'context'];
export function editWhatsappTemplateBoxController($scope,
  $mdDialog,
  AngularWhatsappTemplatesService,
  AlertingFactory,
  elementView,
  context) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.checkValidity = checkValidity;

  init();

  function ok() {
    $mdDialog.hide({ type: 'ok', data: $scope.selectedTemplate });
  }


  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.loading = true;
    $scope.invalid = true;
    const { companyId, site } = context;
    $scope.companyId = companyId;
    $scope.site = site;
    $scope.boxId = elementView.model.id;
    $scope.scenarioId = context.scenarioId;

    $scope.selectedTemplate = elementView.angularScope.elementData || {};
    AngularWhatsappTemplatesService.getAnswerTemplatesForQuickReplies(context.site.id)
      .toPromise()
      .then(result => {
        const templates = (result || []).map(template => {
          const { displayed_placeholders } = template;

          Object.keys(displayed_placeholders || {}).forEach(key => {
            const { label, example } = displayed_placeholders[key];
            if (!label && !example) {
              displayed_placeholders[key] = {
                label: `${displayed_placeholders[key]}`,
                example: '',
              };
            }
          });
          return template;
        })
        $scope.templates = templates;
      },
        AlertingFactory.httpErrorHandler())
      .finally(() => $scope.loading = false);

  }

  function checkValidity(selected) {
    try {
      const hasCopyCodeButtons = (selected.template?.buttons || []).some(({ type, example }) => type === WhatsappTemplateButtonTypeEnum.COPY_CODE && example);
      let copyCodeButtonsInvalid = false;
      if (hasCopyCodeButtons) {
        copyCodeButtonsInvalid = !selected.couponCodeButtonParams ||
          !selected.couponCodeButtonParams.couponCode ||
          // Either a variable name or a word limited to 15 characters.
          !/^{{.+}}$|^.{1,15}$/.test(selected.couponCodeButtonParams.couponCode);
      }

      const hasUrlButtonsWithSuffix = (selected.template?.buttons || []).some(({ type, example }) => type === WhatsappTemplateButtonTypeEnum.URL && example);
      let urlButtonsInvalid = false;
      if (hasUrlButtonsWithSuffix) {
        const urlButtonParamKeys = Object.keys(selected.urlButtonParams || []);
        if (!urlButtonParamKeys.length) {
          urlButtonsInvalid = true;
        } else {
          urlButtonsInvalid = urlButtonParamKeys.some(key => !selected.urlButtonParams[key])
        }
      }

      let limitedTimeOfferExpirationDateInvalid;
      if (selected.template.limited_time_offer) {
        limitedTimeOfferExpirationDateInvalid = !selected.limitedTimeOffer ||
          (!selected.limitedTimeOffer.expirationDate && !selected.limitedTimeOffer.expirationDelay) ||
          (selected.limitedTimeOffer.expirationDate && moment(selected.limitedTimeOffer.expirationDate).isSameOrBefore(moment()));
      }

      $scope.invalid = !selected ||
        !selected.template ||
        limitedTimeOfferExpirationDateInvalid ||
        urlButtonsInvalid ||
        copyCodeButtonsInvalid ||
        Object.keys(selected.params || []).some(key => {
          const param = selected.params[key];
          const { type, value, default: defaultValue } = param;
          return !value || (value && type === 'custom-field' && !defaultValue);
        }) ||
        (selected.template.header && selected.template.header.media_type && !selected.template.header.media_url);
    } catch (e) {
      console.log(e);
      $scope.invalid = true
    }
    $scope.selectedTemplate = selected;
  }
}
